import axios from 'axios';
import base from '@/api/base.api';
const namespace = 'tipos-cuenta';

export default {
    getCommissions: (id) => {
        return axios.get(`${base.baseUrl}/${namespace}/get-commissions/${id}`);
    }
}
